import type { TimelineItem } from '../types'
import { AudioLayer } from './AudioLayer'
import { CaptionsLayer } from './CaptionsLayer'
import { ComponentLayer } from './ComponentLayer'
import { ImageLayer } from './ImageLayer'
import { SolidLayer } from './SolidLayer'
import { TextLayer } from './TextLayer'
import { VideoLayer } from './VideoLayer'

export function InnerLayer({
  item,
  trackMuted,
  cropBackground,
}: {
  item: TimelineItem
  trackMuted: boolean
  cropBackground: boolean
}) {
  switch (item.type) {
    case 'image':
      return <ImageLayer item={item} cropBackground={cropBackground} />
    case 'text':
      return <TextLayer item={item} />
    case 'video':
      return (
        <VideoLayer
          item={item}
          trackMuted={trackMuted}
          cropBackground={cropBackground}
        />
      )
    case 'solid':
      return <SolidLayer item={item} />
    case 'audio':
      return <AudioLayer item={item} trackMuted={trackMuted} />
    case 'captions':
      return <CaptionsLayer item={item} />
    case 'component':
      return <ComponentLayer item={item} />
    case 'scene':
    case 'view':
      // `lowerScenes` turns a sourced scene and its views into the media
      // items that play them (#566); what is left, a title-card scene or a
      // view whose scene is gone, draws nothing of its own.
      return null
    default:
      throw new Error(
        'Unimplemented item type: ' + JSON.stringify(item satisfies never),
      )
  }
}
